/**
 * «Ver conceptos» de Emitidos (spec 2026-10-11 §3.2): la línea hija de cada factura con sus conceptos
 * (window.FDConceptos). Funciones puras que arman HTML ya escapado; los datos llegan de
 * v2/documentos/conceptos_lote_ajax (Cfdi_lista_model::conceptos: hasta 50 por factura, descripción a 300
 * caracteres y su largo real para el «ver más»).
 */
import { esc, dinero, textoConteo } from './pestanas.js';

/** Igual que Cfdi_lista_model::MAX_DESCRIPCION. */
export const MAX_DESCRIPCION = 300;

/** '2.000000' → '2'; '1.50' → '1.5'; '1500' → '1,500'; lo que no es número se queda como viene. */
export function cantidadTexto(c) {
  const n = Number(c);
  if (c === null || c === undefined || c === '' || !Number.isFinite(n)) return String(c == null ? '' : c);
  const partes = String(Number(n.toFixed(6))).split('.');
  return partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (partes[1] ? '.' + partes[1] : '');
}

export function htmlCargando() {
  return '<div class="fd-conceptos fd-hija-espera"><i class="ti ti-loader-2 icon-spin me-1" aria-hidden="true"></i>Trayendo los conceptos…</div>';
}

/**
 * Los conceptos que no llegaron: el texto lo decide la pantalla según el fallo (revisión final, M2: FD.texto.conexion
 * sin red, FD.texto.reintentar en lo demás) y aquí se escapa; sin texto, solo el enlace.
 */
export function htmlReintentar(texto) {
  const t = String(texto == null ? '' : texto).trim();
  return '<div class="fd-conceptos fd-hija-espera">' + (t ? esc(t) + ' ' : '')
    + '<a href="#" class="fd-reintentar">Intentar de nuevo</a></div>';
}

/**
 * Tabla de conceptos de una factura: {total, conceptos:[{id, cantidad, clave, unidad, descripcion, largo, importe}]}.
 * `etiqueta` (opcional): el nombre de la tabla para lector de pantalla («Conceptos de FACT537»).
 */
export function htmlConceptos(bloque, etiqueta) {
  const b = bloque || {};
  const lista = Array.isArray(b.conceptos) ? b.conceptos : [];
  if (!lista.length) {
    return '<div class="fd-conceptos fd-hija-espera">Este comprobante no tiene conceptos registrados en la plataforma.</div>';
  }
  const nombre = String(etiqueta == null ? '' : etiqueta).trim();
  let h = '<div class="fd-conceptos"><table class="fd-conceptos-tabla"' + (nombre ? ' aria-label="' + esc(nombre) + '"' : '') + '><thead><tr>'
    + '<th class="text-end">Cantidad</th><th>Clave</th><th>Descripción</th><th class="text-end">Importe</th>'
    + '</tr></thead><tbody>';
  lista.forEach(function (c) {
    const texto = String(c.descripcion == null ? '' : c.descripcion);
    const largo = Number(c.largo) || texto.length;
    h += '<tr>'
      + '<td class="text-end col-num">' + esc(cantidadTexto(c.cantidad)) + '</td>'
      + '<td class="font-mono" title="' + esc(c.unidad || '') + '">' + esc(c.clave || '—') + '</td>'
      + '<td class="fd-concepto-desc">' + esc(texto)
      + (largo > MAX_DESCRIPCION ? '… <a href="#" class="fd-ver-mas" data-detalle="' + esc(c.id) + '">ver más</a>' : '')
      + '</td>'
      + '<td class="text-end col-num">' + esc(dinero(c.importe)) + '</td>'
      + '</tr>';
  });
  h += '</tbody></table>';
  const total = Number(b.total) || lista.length;
  if (total > lista.length) {
    h += '<div class="fd-conceptos-pie">Mostramos los primeros ' + lista.length + ' de ' + textoConteo(total)
      + ' conceptos; el PDF los trae todos.</div>';
  }
  return h + '</div>';
}
